module.exports = __webpack_public_path__ + "img/logo-conecta.d72c05c9.svg";